import { Card, CardBody, Col } from "reactstrap";
import { InlineStyleTitle } from "../../../../../../Constants/Constants";
import { InlineStyleSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonCardFooter from "../../../Common/CommonCardFooter";
import InlineStyleForm from "./InlineStyleForm";

const InlineStyle = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={InlineStyleTitle} span={InlineStyleSubTitle} />
        <CardBody className="megaoptions-border-space-sm">
          <InlineStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="warning" color2="transparent" btn2Class="list-light-warning" />
      </Card>
    </Col>
  );
};
export default InlineStyle;
